export default __webpack_public_path__ + "static/media/litchi.34d0d961.png";